import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class Date extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

	render() {
        return <React.Fragment><div>{Formatting.formatDate(this.props.value)}</div></React.Fragment>
    }
}

export default Date;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/Date.js